import React, { useEffect, useState } from 'react'
import "./ManageDetail.css"
import { useSelector ,useDispatch} from 'react-redux'
import { fetchuserAds } from '../../features/User/UserAction'
export default function ManageDetail() {

    const dispatch = useDispatch();
  const { BookWormUser } = useSelector((state) => state)
  const { userInfo } = BookWormUser
  useEffect(() => {
        
        dispatch(fetchuserAds({userId:userInfo._id}))
    },[])


  return (
       <div className="manageDetails">
            <h3 style={{margin:"20px 0"}} >Manage Your Profile</h3>
            <div className="detail">
                <div className="detailHeading"><span><strong> Your Name</strong></span></div>                      
              <div className="detailValue"><span >{ userInfo.name}</span></div>
            </div>
            <hr style={{width:"80%"}} />
            <div className="detail">
                <div className="detailHeading"><span><strong> Email Address</strong></span></div>                  
              <div className="detailValue"><span >{userInfo.email }</span></div>
            </div>
            <hr style={{width:"80%"}} />
            <div className="detail">
                <div className="detailHeading"><span><strong>Phone Number</strong></span></div>                      
              <div className="detailValue"><span >{ userInfo.contact}</span></div>
            </div>
            <hr style={{width:"80%"}} />
            <div className="detail">
                <div className="detailHeading"><span><strong> Location</strong></span></div>                      
              <div className="detailValue"><span >{ userInfo.location}</span></div>
            </div>
            <hr style={{width:"80%"}} />
            <div className="detail">
                <div className="detailHeading"><span><strong> Total ADs</strong></span></div>                      
              <div className="detailValue"><span >{ userInfo.ads ? userInfo.ads.pending.length: 0 +  userInfo.ads ? userInfo.ads.sold.length : 0 +  userInfo.ads ? userInfo.ads.approved.length : 0  + userInfo.ads ? userInfo.ads.negotiation.length :0}</span></div>
            </div>
            <hr style={{width:"80%"}} />
            <div className="detail">
                <div className="detailHeading"><span><strong> Aprooved Ads</strong></span></div>                      
              <div className="detailValue"><span >{ userInfo.ads ? userInfo.ads.approved.length :0}</span></div>
            </div>
            <hr style={{width:"80%"}} />
            <div className="detail">
                <div className="detailHeading"><span><strong> Unaprooved Ads</strong></span></div>                      
              <div className="detailValue"><span >{  userInfo.ads ? userInfo.ads.pending.length:0}</span></div>
            </div>
            <hr style={{width:"80%"}} />                  
            <div className="detail">
                <div className="detailHeading"><span><strong> Sold Ads</strong></span></div>                      
              <div className="detailValue"><span >{ userInfo.ads ? userInfo.ads.sold.length:0}</span></div>
            </div>
            <hr style={{width:"80%"}} />                
            <div className="detail">
                <div className="detailHeading"><span><strong> StreetAddress</strong></span></div>                      
              <div className="detailValue">
                <span >{ userInfo.shippingAddress ? userInfo.shippingAddress.streetAddress:""}</span>
                </div>
            </div>
            <hr style={{width:"80%"}} />                  
            <div className="detail">
                <div className="detailHeading"><span><strong> city</strong></span></div>                      
              <div className="detailValue">
                <span >{ userInfo.shippingAddress?userInfo.shippingAddress.city:""}</span>
                </div>
            </div>
            <hr style={{width:"80%"}} />                  
            <div className="detail">
                <div className="detailHeading"><span><strong> state</strong></span></div>                      
              <div className="detailValue">
                <span >{ userInfo.shippingAddress ? userInfo.shippingAddress.state : ""}</span>
                </div>
            </div>
            <hr style={{width:"80%"}} />                  
            <div className="detail">
                <div className="detailHeading"><span><strong> Area Pincode</strong></span></div>                      
              <div className="detailValue">
                <span >{ userInfo.shippingAddress ? userInfo.shippingAddress.pincode: ""}</span>
                </div>
            </div>
            <hr style={{width:"80%"}} />                  
        </div>
  )
}
